import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './lib/polyfills.js';
import {pick} from 'lodash';

window.addEventListener("load",function() {
    // Set a timeout...
    setTimeout(function(){
        // Hide the address bar!
        window.scrollTo(0, 1);
    }, 0);
});

// accces point for global (and possibly other) objects in MCC client (?just use window)
let clientBridge = {connected:false};
const ClientBridge = React.createContext(clientBridge);
export {ClientBridge};

// Expose function to attach top level components as needed
window.reactLoaderMobile = function(id, name, props, children) {

    // List of exposed components
    const lookup = {
        App
    };

    // pickup at mount
    if (window.mcc) {
        clientBridge = {
            connected:true,
            ...pick(window,'mcc','wizard','mccLogin','model')
        };
    }

    const elem = React.createElement(lookup[name], props, children);
    ReactDOM.render(
        <ClientBridge.Provider value={clientBridge} children={elem}/>
        , document.getElementById(id));

    if ('_' in window  && window._ && 'cloneDeep' in window._ ) {
        console.log('Lodash releasing window._ - reactLoader');
        window._.noConflict();
    }
    if (!('_' in window ) || !window._ || !('pluck' in window._) ) {
        console.log('No underscore at window._  - reactLoader');
    }

    return elem;
};


// Prevent Test App start if embedding in MCC
// Leave MCC to add elements as needed.
if (!window.mcc) {
    ReactDOM.render(
        <React.StrictMode>
            <ClientBridge.Provider value={clientBridge} >
                <App/>
            </ClientBridge.Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );
} else {
    // Additional MCC embeded set up
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
